var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticStyle:{"padding":"5px 5px 5px 5px"},attrs:{"md":"12","sm":"8"}},[_c('b-card',{staticClass:"mx-4",attrs:{"no-body":""}},[_c('b-card-header',{attrs:{"header-bg-variant":"primary","header-text-variant":"white"}},[_c('h4',{staticClass:"titulo",staticStyle:{"font-size":"24px !important"}},[_c('span',{staticClass:"bold"},[_vm._v("Formulário "+_vm._s(_vm.questionario.titulo))])])]),_vm._v(" "),_c('b-card-body',{staticClass:"p-4"},[_c('h5',{staticClass:"text-center bold"},[_vm._v(_vm._s(_vm.mensagem))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/site/externa/Mensagem.vue?vue&type=template&id=477901cc&scoped=true
// module id = null
// module chunks = 